<template>
  <div
    ref="pointer"
    class="cursor"
    >
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 77">
        <path class="cursor-hover" d="M24.6 72.1C14.9 69.8 7.3 62.2 5 52.4-.3 43.9-.3 33.1 5 24.6 7.3 14.9 14.9 7.3 24.6 5 33.1-.3 43.9-.3 52.3 5 62 7.3 69.6 14.9 72 24.7c5.3 8.5 5.3 19.3 0 27.8-2.3 9.7-9.9 17.3-19.7 19.7-8.4 5.1-19.2 5.1-27.7-.1z" fill="#ffd300" stroke="#ffd300" stroke-width="2"/>
        <path class="cursor-mdown" d="M24.6 72.1C14.9 69.8 7.3 62.2 5 52.4-.3 43.9-.3 33.1 5 24.6 7.3 14.9 14.9 7.3 24.6 5 33.1-.3 43.9-.3 52.3 5 62 7.3 69.6 14.9 72 24.7c5.3 8.5 5.3 19.3 0 27.8-2.3 9.7-9.9 17.3-19.7 19.7-8.4 5.1-19.2 5.1-27.7-.1z" fill="#ffd300" stroke="#ffd300" stroke-width="2" ref="pathmdown" />
      </svg>
    </span>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex';
import { TweenLite } from 'gsap/TweenLite';
import loop from 'raf-loop';
import Eventer from 'eventer-js';

import animations from '@/scripts/animations';
import { qs, isMobile, lerp, roundDec } from '@/scripts/utils';


export default {
  name: 'Pointer',

  props: ['isCursorReady', 'loading'],

  data() {
    return {
      buttons: [],

      mouse: { x: 0, y: 0 },
      interMouse: { x: 0, y: 0 },
      norm: { x: 0, y: 0 },

      magnetism: 5,
      attraction: 30,

      isLerp: true,
      lerp,
      roundDec,
      isMobile,

      oldCtx: null,
      newCtx: null,

      visible: true,

      timer: null,
      played: false,

      checkSwitch: false,
    };
  },

  computed: {
    ...mapGetters({
      stateCtx: 'getCtxButtons',

      page: 'getRouteName',

      changeLang: 'getChangeLang',
    }),
  },

  watch: {
    page(newCtx, oldCtx) {
      if (newCtx === 'home') {
        this.addMouseDown();
      } else if (oldCtx === 'home') {
        this.removeMouseDown();
      }
    },

    stateCtx(newCtx, oldCtx) {
      if (oldCtx !== null && !this.isMobile() && !oldCtx.hasAttribute('js-noremove')) {
        const els = Array.from(oldCtx.querySelectorAll('[data-mouse]'));
        this.removeButtonsEvents(els);
      }
      if (!this.isMobile()) {
        const els = Array.from(newCtx.querySelectorAll('[data-mouse]'));
        this.addButtonsEvents(els);
      }
    },

    loading(newVal) {
      if (!newVal && !isMobile()) {
        this.buttons = Array.from(document.querySelectorAll('[data-mouse]'));
        this.init();

        if (this.$store.state.route.name === 'home') this.addMouseDown();
      }
    },

    changeLang(newVal) {
      if (newVal) {
        TweenLite.set(this.switchTrans, {
          top: this.interMouse.y,
          left: this.interMouse.x,
        });

        this.checkSwitch = true;
      } else {
        this.checkSwitch = false;
      }
    },
  },

  mounted() {
    this.eventer = new Eventer(true);
    this.init();

    this.animateMdown = animations.get('cursor')(this.$refs.pathmdown);
  },

  methods: {
    init() {
      this.switchTrans = qs('.el-transition');
      this.bindEvents();

      TweenLite.to(this.$el, 0.4, { opacity: 1 });
      this.engine = loop(this.renderer.bind(this)).start();
    },

    mousePosition(event) {
      this.mouse = {
        x: event.clientX,
        y: event.clientY,
      };
    },

    bindEvents() {
      window.addEventListener('mousemove', this.mousePosition.bind(this));
      // this.eventer.bindEvent('mousemove', window, this.mousePosition.bind(this));

      this.addButtonsEvents(this.buttons);
    },

    addButtonsEvents(btns) {
      if (btns.length === 0) return;

      btns.forEach((btn) => {
        const state = btn.getAttribute('data-mouse-attractionstate');
        const attraction = btn.getAttribute('data-mouse-attractionval');

        this.handleMouseMove = this.setButtonPosition.bind(this);

        if (state === 'active' || state === true) this.eventer.bindEvent('mousemove', btn, event => this.handleMouseMove(event, btn, attraction));
        this.eventer.bindEvent('mouseenter', btn, this.setHoverMouse.bind(this, btn));
        this.eventer.bindEvent('mouseleave', btn, this.resetButton.bind(this, btn, state));
      });
    },

    addMouseDown() {
      this.handleMouseDown = event => this.mouseDown(event);
      this.handleMouseUp = this.mouseUp.bind(this);

      document.body.addEventListener('mousedown', this.handleMouseDown);
      document.body.addEventListener('mouseup', this.handleMouseUp);
    },

    removeMouseDown() {
      document.body.removeEventListener('mousedown', this.handleMouseDown);
      document.body.removeEventListener('mouseup', this.handleMouseUp);
    },

    mouseDown(event) {
      if (
        event.target.hasAttribute('data-line') ||
        event.target.classList.contains('js-splittedlines') ||
        event.target.classList.contains('event') ||
        event.target.classList.contains('event__title')
      ) return;

      this.$el.setAttribute('data-hover', 'mdown');
      this.animateMdown.timeScale(2.8).play();

      this.timer = setTimeout(() => {
        // this.played = true;

        this.$store.commit('TOGGLE_MOUSEDOWN', true);
        this.$el.setAttribute('data-hover', '');

        // this.sound.play();
        // this.sound.fade(0, 0.5, 2000);
      }, 400);
    },

    mouseUp() {
      this.$el.setAttribute('data-hover', '');
      this.animateMdown.pause().timeScale(2.5).reverse();

      // if (this.played) {
      //   this.sound.fade(0.5, 0, 1500);
      //   this.played = false;
      // }

      this.$store.commit('TOGGLE_MOUSEDOWN', false);
      clearTimeout(this.timer);
    },

    removeButtonsEvents(btns) {
      btns.forEach(btn => this.eventer.clearAll(btn));
    },

    renderer() {
      this.setPos();
    },

    setPos() {
      const lerpedX = lerp(this.mouse.x, this.interMouse.x, 0.75);
      const lerpedY = lerp(this.mouse.y, this.interMouse.y, 0.75);

      this.interMouse.x = this.isLerp ? lerpedX - (this.norm.x / this.magnetism) : this.mouse.x;
      this.interMouse.y = this.isLerp ? lerpedY - (this.norm.y / this.magnetism) : this.mouse.y;

      TweenLite.set(this.$el, {
        x: this.interMouse.x,
        y: this.interMouse.y,
      });

      if (this.checkSwitch) {
        TweenLite.set(this.switchTrans, {
          top: this.interMouse.y,
          left: this.interMouse.x,
        });
      }
    },

    setHoverMouse(el) {
      this.$el.setAttribute('data-hover', el.getAttribute('data-hover-type'));
    },

    setButtonPosition(event, el, attraction) {
      this.dim = {
        x: el.clientWidth / 2,
        y: el.clientHeight / 2,
      };

      this.norm = {
        x: roundDec((event.offsetX - this.dim.x) / this.dim.x) * attraction,
        y: roundDec((event.offsetY - this.dim.y) / this.dim.y) * attraction,
      };

      this.animateButton(el);
    },

    animateButton(el) {
      TweenLite.to(el, 0.5, {
        xPercent: this.norm.x,
        yPercent: this.norm.y,
      });
    },

    resetButton(el, state) {
      this.$el.setAttribute('data-hover', '');

      if (state === 'active' || state) {
        this.norm = { x: 0, y: 0 };
        this.animateButton(el);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/colors";
@import "../application";

.cursor {
  display: none;

  @include mq(sm) {
    position: absolute;
    top: calc(-75px / 2);
    left: calc(-75px / 2);
    width: 75px;
    height: 75px;

    opacity: 0;

    transform-origin: center;
    border-radius: 50%;
    pointer-events: none;

    display: flex;
    align-items: center;
    justify-content: center;

    z-index: -1;
  }

  mix-blend-mode: multiply;

  span {
    position: relative;
    width: 100%;
    height: 75px;
    pointer-events: none;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;

      opacity: 0;

      transition: all 0.3s ease-out 0.2s;
      transform-origin: 50% 50%;

      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    transform-origin: 50% 50%;

    pointer-events: none;

    @at-root .no-smil & {
      transform: scale(0.3);
    }
  }

  path.cursor-hover {
    stroke: $color-primary;
    stroke-width: 2;

    transform-origin: 50% 50%;
    transition: all 0.2s ease-out;

    @at-root .smil & {
      transform: scale(0.3);
    }
  }

  path.cursor-mdown {
    fill: $color-primary;
    fill-opacity: 0;
    stroke: $color-primary;
    stroke-width: 2;

    transform-origin: 50% 50%;
  }

  @at-root {
    .nite {
      path.cursor-hover,
      path.cursor-mdown {
        fill: $color-secondary;
        stroke: $color-secondary;
      }
    }
  }

  &[data-hover="zoom"] svg {
    @at-root .no-smil & {
      transform: scale(1);
    }

    path.cursor-hover {
    fill-opacity: 0;

    transform: scale(1);
    }
  }

  &[data-hover="mdown"] svg {

    @at-root .no-smil & {
      transform: scale(0);
    }

    path.cursor-hover {
      transform: scale(0);
      transform-origin: 50% 50%;
    }
  }

  &[data-hover="lang"] svg {
    @at-root .no-smil & {
      transform: scale(0.8);
    }

    path.cursor-hover {
      transform: scale(0.8);
    }
  }
}
</style>

<style lang="scss">
.cursor {
  &.left {
    &-hold {
      span {
        &::before {
          content: '';
          top: -6px;
          left: -6px;
          background: url('/static/vector/click.svg');

          opacity: 1;
          transition-delay: 0.4s;
        }
      }
    }

    &-drag {
      span {
        &::before {
          content: '';
          top: -6px;
          left: 6px;
          background: url('/static/vector/drag.svg');

          opacity: 1;
          transition-delay: 0s;

          transform: rotate(90deg) translateZ(0);
        }
      }
    }
  }
  &.right {
    &-hold {
      span {
        &::before {
          content: '';
          top: -6px;
          left: 6px;
          background: url('/static/vector/click.svg');

          opacity: 1;
          transition-delay: 0.4s;

          transform: rotate(90deg) translateZ(0);
        }
      }
    }

    &-drag {
      span {
        &::before {
          content: '';
          top: 6px;
          left: 6px;
          background: url('/static/vector/drag.svg');

          opacity: 1;
          transition-delay: 0s;
          transform-origin: 50% 50%;

          transform: rotate(0deg) translateX(-12px) translateY(-15px) translateZ(0);
        }
      }
    }
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Pointer.vue